/* eslint-disable no-console */
const warn = (s: string): void => {
  console.warn('[gtm]', s);
};

export default warn;
